export function secoesBlocos() {
  return [
    {
      id: 'gatilho',
      titulo: 'Gatilhos',
      itens: [
        { id: 'oportunidade_criada', titulo: 'Criação de oportunidade', icone: 'fas fa-folder-plus', disponivel: true },
        { id: 'oportunidade_ganha', titulo: 'Oportunidade ganha', icone: 'fas fa-trophy', disponivel: true },
        { id: 'oportunidade_perdida', titulo: 'Oportunidade perdida', icone: 'fas fa-times-circle', disponivel: true },
        { id: 'mudanca_fase', titulo: 'Mudança de fase', icone: 'fas fa-exchange-alt', disponivel: true },
        { id: 'mudanca_status', titulo: 'Mudança de status', icone: 'fas fa-flag', disponivel: true },
        { id: 'cadastro_cliente', titulo: 'Cadastro de cliente', icone: 'fas fa-user-plus', disponivel: true },
        { id: 'resposta_mensagem', titulo: 'Resposta de mensagem', icone: 'fas fa-reply', disponivel: true },
        { id: 'preenchimento_campo', titulo: 'Preenchimento de campo', icone: 'fas fa-check-square', disponivel: true },
      ],
    },
    {
      id: 'condicao',
      titulo: 'Condições',
      itens: [
        { id: 'pipeline_id', titulo: 'Pipeline', icone: 'fas fa-filter', disponivel: true },
        { id: 'valor', titulo: 'Valor da oportunidade', icone: 'fas fa-dollar-sign', disponivel: true },
        { id: 'origem', titulo: 'Origem', icone: 'fas fa-globe', disponivel: true },
        { id: 'horario', titulo: 'Horário de atendimento', icone: 'fas fa-clock', disponivel: true },
        { id: 'campo', titulo: 'Campo', icone: 'fas fa-list', disponivel: true },
        { id: 'resposta', titulo: 'Resposta', icone: 'fas fa-comment-dots', disponivel: true },
      ],
    },
    {
      id: 'acao',
      titulo: 'Ações',
      itens: [
        { id: 'criar_oportunidade', titulo: 'Criar oportunidade', icone: 'fas fa-plus', disponivel: true },
        { id: 'criar_tarefa', titulo: 'Criar tarefa', icone: 'fas fa-tasks', disponivel: true },
        { id: 'mover_fase', titulo: 'Mover fase', icone: 'fas fa-arrow-right', disponivel: true },
        { id: 'alterar_responsavel', titulo: 'Alterar responsável', icone: 'fas fa-user-tag', disponivel: true },
        { id: 'enviar_mensagem', titulo: 'Enviar e-mail ou mensagem', icone: 'fas fa-comment', disponivel: true },
        { id: 'atualizar_campo', titulo: 'Atualizar campo', icone: 'fas fa-edit', disponivel: true },
        { id: 'notificar_gestor', titulo: 'Gerar notificação', icone: 'fas fa-bell', disponivel: true },
      ],
    },
  ]
}

export function secoesParaAdicionar(temGatilho) {
  if (!temGatilho) {
    return secoesBlocos().filter(function (secao) {
      return secao.id === 'gatilho'
    })
  }

  return secoesBlocos().filter(function (secao) {
    return secao.id !== 'gatilho'
  })
}
